import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React from 'react';

import { StoreKeys } from '../../../hooks/useStore/state';
import { useStore } from '../../../hooks/useStore/useStore';
import { adobeLinkTrackEvent } from '../../AdobeTagging/adobeLinkTrackEvent';
import { phoneOnly } from '../../ConstantsStyles';
import {
  NavigationButtonBox,
  NavigationButtonBoxContainer,
} from './NavigationButton.styled';

type Props = {
  buttonNavType: string;
  curNavType: string;
  id?: string;
  setNavType(navType: string): void;
  locationForAnalytics?: string;
  label: string;
};

const getMaterialIcon = (navType) => {
  switch (navType) {
    case 'driving':
      return 'drive_eta';
    case 'walking':
      return 'directions_walk';
    case 'cycling':
      return 'directions_bike';
    default:
      return 'traffic';
  }
};

export const NavigationButton = ({
  buttonNavType,
  curNavType,
  setNavType,
  id,
  locationForAnalytics,
  label,
}: Props) => {
  const isWidget = useStore(StoreKeys.IS_WIDGET);
  const phoneScreen = useMediaQuery(phoneOnly) && !isWidget;
  const INACTIVE_NAV_BUTTON = phoneScreen
    ? '$core.color.neutral.10'
    : ' $core.color.neutral.0';
  const INACTIVE_NAV_ICON = '#323334';
  const navigationDataTestId: string = `navigation-${buttonNavType}`;
  const handleLinkTrack = (linkName: string, linkLocation?: string) => {
    adobeLinkTrackEvent({
      name: linkName,
      location: linkLocation,
      type: 'internal',
    });
  };
  return (
    <NavigationButtonBoxContainer color={INACTIVE_NAV_BUTTON}>
      <NavigationButtonBox
        aria-label={label}
        css={{
          background:
            buttonNavType === curNavType
              ? '$core.color.brand.60'
              : INACTIVE_NAV_BUTTON,
        }}
        data-auto-testid={navigationDataTestId}
        data-testid={navigationDataTestId}
        id={id}
        onClick={() => {
          handleLinkTrack(
            navigationDataTestId,
            `modal:${locationForAnalytics}`
          );
          setNavType(buttonNavType);
        }}
      >
        <IconSymbol
          color={buttonNavType === curNavType ? 'white' : INACTIVE_NAV_ICON}
          icon={getMaterialIcon(buttonNavType)}
        />
      </NavigationButtonBox>
    </NavigationButtonBoxContainer>
  );
};
